<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-8.jpg)' }"
  class="content-header"
>
  <h2 class="header-title">Parachutes</h2>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="modalConfirmed($event)"
  (denied)="modalDenied($event)"
>
</app-modal>
<div class="random-actions">

  <div class="app-dropdown" *ngIf="userIsSysAdmin && bases !== []">
    <app-dropdown
      [choice]="selectedBase"
      [options]="bases"
      key="name"
      label="Base"
      (selectedDropdownItem)="selectHomeBase($event)"
    ></app-dropdown>
  </div> 
  <div *ngIf="!userIsSysAdmin || bases === []">
    <span class="base"> Base: {{ userInfo.baseName }} ({{ userInfo.baseCode }})</span>      
  </div>

  <app-dropdown class="app-dropdown"
    *ngIf="true"
    [(choice)]="type"
    label="Chute Type"
    [options]="[
      { name: 'All', value: 'All' },
      { name: 'Main', value: 'Main' },
      { name: 'Drogue', value: 'Drogue' },
      { name: 'Reserve', value: 'Reserve' }
    ]"
    key="value"
    (selectedDropdownItem)="selectType($event)"
  ></app-dropdown>
</div>
<app-table
  hasActions="true"
  [settings]="settings"
  [rows]="chutes"
  [columns]="headings"
  (deleted)="confirmDelete($event)"
  [tableCellTemplate]="cellTemplate"
>
  <ng-template #cellTemplate let-cell="cell">
    <div class="cell">
      <span>{{ cell.value }}</span>
    </div>
  </ng-template>
</app-table>
